<template>
    <div class="loginWrap">
        <div class="myIcon" @click="$emit('openRegister')">
            <font-awesome-icon class="icon" icon="pen"/>
        </div>

        <div v-if="loading" class="spinner">
            <sync-loader
                    class="loaderDots"
                    :size="8"
                    :loading="loading"
            />
        </div>
        <form>
            <h3>{{$t('loginVue.loginTitle')}}</h3>
            <input
                    @click="errorMessage=false"
                    required
                    :class="{redOutline: errorMessage}"
                    v-model="user.email"
                    type="email"
                    :placeholder="$t('loginVue.emailPlaceholder')">
            <input
                    @click="errorMessage=false"
                    v-model="user.password"
                    :class="{redOutline: errorMessage}"
                    type="password"
                    :placeholder="$t('loginVue.passwordPlaceholder')"
                    required>
            <input class="form-input" @click.prevent="submitLogin" :value="$t('loginVue.loginButton')" type="submit">
        </form>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import router from "../../router";

    export default {
        name: "login",
        data() {
            return {
                user: {
                    email: '',
                    password: '',
                },
                errorMessage: false,
                loading: false
            }
        },
        methods: {
            submitLogin() {
                this.trimInputs();

                if (this.user.email && this.user.password) {
                    this.loading = true;
                    this.$store.dispatch('authUser', this.user).then(response => {
                        if (response.status === 200) {
                            router.push({name: 'contractors'});
                            this.$store.dispatch('getContractors');
                        } else {
                            this.loading = false;
                            this.errorMessage = true;
                            this.$swal("Error", response, "error");
                        }
                        this.loading = false;
                    });
                } else {
                    this.errorMessage = true;
                    this.openWarningAlert();

                }
            },
            clearErrorMessage() {
                this.errorMessage = true;
                this.user.password = '';
            },
            trimInputs() {
                this.user.email.trim();
                this.user.password.trim();
            },
            openWarningAlert() {
                return this.$swal({
                    title: "Ouups!",
                    text: "Seems like some fields are not filled in",
                    icon: "warning",
                    buttons: { confirm: true}
                }).then(this.clearErrorMessage);
            }
        },
        computed: {
            ...mapGetters([
                'getRole'
            ]),
        },
    }
</script>

<style lang="scss">
    @import "./src/assets/colors.scss";

    .redOutline {
        transition: 0.2s ease all;
        border: 1px solid red !important;
    }

    .loginWrap {
        .myIcon {
            width: 2em;
            height: 1.75em;
            position: absolute;
            right: 0;
            cursor: pointer;
            display: flex;

            .icon {
                color: $gray !important;
                margin: auto;
            }
        }

        h3 {
            color: #0B193E;
            letter-spacing: 0.05em;
            margin: 0.5em 0 1em 0;

        }

        form {
            margin: 2em;

            input {
                border: 1px solid $company-primary;
                padding: 1em;
                outline: none;
                margin-bottom: 1em;
                display: block;
                width: 100%;
                box-sizing: border-box;
                font-wieght: 400;
                transition: 0.25s ease all;

                &:focus {
                    border: 1px solid $company-accent;
                }

            }

            input[type=submit] {
                cursor: pointer;
                background: $company-accent;
                width: 100%;
                border: 0;
                padding: 1em;
                color: $gray;
                text-transform: uppercase;

                &:hover {
                    transition: all 0.3s ease-in-out;
                    background: $company-accent;
                }
            }
        }
    }

    .spinner {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #FFFFFF88;
        border-bottom-right-radius: 2em;
        border-top-left-radius: 2em;
    }

    .loaderDots {
        position: absolute;
        top: 45%;
        left: 45%;

    }


</style>
